import { render, staticRenderFns } from "./CollectionBulkEdit.vue?vue&type=template&id=74ff78b6&scoped=true"
import script from "./CollectionBulkEdit.vue?vue&type=script&lang=js"
export * from "./CollectionBulkEdit.vue?vue&type=script&lang=js"
import style0 from "./CollectionBulkEdit.vue?vue&type=style&index=0&id=74ff78b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ff78b6",
  null
  
)

export default component.exports